import React from 'react'
const About = () => {
    return (
        <div className = 'about'>
            <h1>Hi, I'm Briahana Maugé!</h1>
            <p>I am a math teacher by day, early-career full stack web developer by night. </p>
            <p>When I'm not building projects, you can find me binging Netflix shows, listening to my favorite podcasts, or at a concert.
            Check out my projects and I am looking forward to connecting with you!</p>
        </div>
    )
}

export default About;
